import { FC, ReactElement } from 'react';

import { NavButton, PrimaryButton } from './ui';

import { ButtonTypes, IFLButton, INavButton, IPrimaryButton } from './Button.types';

interface PropsType extends Omit<IFLButton, ''> {
  type: ButtonTypes;
}

type ButtonMapperType = {
  [key in ButtonTypes]: ReactElement;
};

const ButtonVariant: FC<PropsType> = props => {
  const buttonMapper: ButtonMapperType = {
    primary: <PrimaryButton {...(props as IPrimaryButton)} />,
    navigation: <NavButton {...(props as INavButton)} />,
  };

  return buttonMapper[props.type];
};

export default ButtonVariant;
